import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { fmtDate } from '../../../../utils/fmt';

const OpportunityNotificationListDetails = () => {
  const { opportunityId } = useParams();
  const [opportunity, setOpportunity] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [users, setUsers] = useState({});
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchOpportunityDetails();
        await fetchOpportunityNotifications();
        await fetchUsers();
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false); // Set loading to false after data fetching
      }
    };

    fetchData();
  }, [opportunityId]);

  const fetchOpportunityDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.opportunity}${opportunityId}/`, { headers });
      setOpportunity(Array.isArray(response.data) ? response.data : (response.data?.data ?? []));
    } catch (error) {
      console.error('Error fetching opportunity details:', error);
    }
  };

  const fetchOpportunityNotifications = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.opportunityNotification}${opportunityId}/`, { headers });
      setNotifications(Array.isArray(response.data) ? response.data : (response.data?.data ?? []));
    } catch (error) {
      console.error('Error fetching opportunity notifications:', error);
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.users}`, { headers });
      const userMap = (Array.isArray(response.data) ? response.data : (response.data?.data ?? [])).reduce((acc, user) => {
        acc[user.id] = user.username;
        return acc;
      }, {});
      setUsers(userMap);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const columns = [
    { label: 'Message', value: 'message' },
    { 
      label: 'Recipient', 
      value: (item) => users[item.recipient] || 'Unknown User'  // Use the user ID to get the username
    },
    { label: 'Date', value: (item) => fmtDate(item.date) },
  ];

  return (
    <div>
      {loading ? (
        <p>Loading...</p> // Loading state
      ) : (
        <>
   
          {notifications.length > 0 ? (
            <ListTemplate
              columns={columns}
              data={notifications}
              title="Opportunity Notifications"
            />
          ) : (
            <p>No notifications found.</p> // Indicate no notifications
          )}
        </>
      )}
    </div>
  );
};

export default OpportunityNotificationListDetails;
